import { BaseModal } from "./base_modal"
import { hide, show, addClass, removeClass } from "../lib/helpers"

const SELECTED_CLASS = "selected"
const deselect = e => removeClass(e, SELECTED_CLASS)
const select = e => addClass(e, SELECTED_CLASS)

export default class extends BaseModal {
  static targets = [
    "statusSlider",
    "statusText",
    "statusCircle",
    "completionSlider",
    "goalId"
  ]

  // No URL writes of its own: this modal lives in the remote_modal frame, so
  // setup/modal_url_state.js already puts ?modal_url= in the address bar and
  // makes back close it. Writing trigger params too left a second entry under
  // the modal's, and back to it clicked the status circle again.
  showModal(event) {
    super.showModal(event)

    this.setupStatusSlider()
    this.setupCompletionSlider()
  }

  // Support functions

  setupStatusSlider() {
    const statusValue = this.statusSliderTarget.value

    this.updateStatusSlider(statusValue)
    this.updateStatusCircles(statusValue)
  }

  setupCompletionSlider() {
    const completionValue = this.completionSliderTarget.value

    this.updateCompletionSlider(completionValue)
  }

  statusPick(event) {
    const { index } = event.currentTarget.dataset

    this.updateStatusSlider(index)
    this.updateStatusCircles(index)
    // Setting the slider programmatically fires no native event; dispatch
    // one so dirty-form registers the circle click as an edit.
    this.statusSliderTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  statusSlide(event) {
    const { value } = event.currentTarget

    this.updateStatusSlider(value)
    this.updateStatusCircles(value)
  }

  updateStatusSlider(value) {
    // Given a value 0-4
    this.statusSliderTarget.value = value
  }

  updateStatusCircles(index) {
    // given a value 0-4

    // Only show relevant status text and highlight statusCircle
    const statusTexts = this.statusTextTargets
    const statusCircles = this.statusCircleTargets

    const selectedStatusText = statusTexts[index]
    const selectedStatusCircle = statusCircles[index]

    hide(statusTexts)
    deselect(statusCircles)
    show(selectedStatusText)
    select(selectedStatusCircle)

    // Tint the slider thumb with the selected status color (see scss).
    this.statusSliderTarget.dataset.status = selectedStatusText.dataset.value

    const percent = Number(this.completionSliderTarget.value)
    const isNotStarted = selectedStatusText.dataset.value === statusTexts[0].dataset.value
    const isCompleted = selectedStatusText.dataset.value === statusTexts[statusTexts.length - 1].dataset.value

    if (isNotStarted) this.updateCompletionSlider(0)
    if (isCompleted) this.updateCompletionSlider(100)
    if (!isCompleted && percent === 100) this.updateCompletionSlider(0)
  }

  completionSlide(event) {
    const { value } = event.currentTarget

    // Dragging completion on a not-started goal means work has begun.
    if (value > 0 && this.statusSliderTarget.value === "0") {
      // Derive on_track's slider index from the status text targets instead
      // of hard-coding it, so a reordered status enum can't break the jump.
      const onTrackIndex = this.statusTextTargets.findIndex(
        target => target.dataset.value === "on_track"
      )

      if (onTrackIndex !== -1) {
        this.updateStatusSlider(onTrackIndex)
        this.updateStatusCircles(onTrackIndex)
      }
    }

    this.updateCompletionSlider(value)
  }

  updateCompletionSlider(percent) {
    this.completionSliderTarget.value = percent
    this.completionSliderTarget.updateLabel && this.completionSliderTarget.updateLabel()

    // Slider values are strings; compare as numbers ("60" < "100" is false).
    const value = Number(percent)
    const isCompleted = this.statusSliderTarget.value === "4"

    if (value === 100 && !isCompleted) {
      this.updateStatusSlider(4)
      this.updateStatusCircles(4)
    }
    if (value < 100 && isCompleted) {
      this.updateStatusSlider(3)
      this.updateStatusCircles(3)
    }
  }
}